import { getFiscalYears, deleteFiscalYear as deleteFiscalYearApi } from '../services/api';
import { createEntityStore } from '@redpanda/utils';
import { toast } from 'react-hot-toast';

interface FiscalYear {
  id: string;
  organizationId: string;
  name: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
  isClosed: boolean;
  description?: string;
  createdAt: string;
  updatedAt: string;
  periods?: any[];
  _count?: {
    periods: number;
    yearEndEntries: number;
  };
}

const useFiscalYearStoreBase = createEntityStore<FiscalYear>({
  entityName: 'fiscal-years',
  fetchFn: (page: number) => getFiscalYears(page, 20),
  deleteFn: deleteFiscalYearApi,
  toast
});

export const useFiscalYearStore = () => {
  const store = useFiscalYearStoreBase();
  
  return {
    fiscalYears: store.items,
    pagination: store.pagination,
    currentPage: store.currentPage,
    error: store.error,
    isLoading: store.isLoading,
    isPageLoading: store.isPageLoading,
    showDeleteConfirmModal: store.showDeleteConfirmModal,
    itemToDeleteId: store.itemToDeleteId,
    isDeleting: store.isDeleting,
    fetchFiscalYears: store.fetchItems,
    setCurrentPage: store.setCurrentPage,
    handleDelete: store.handleDelete,
    confirmDelete: store.confirmDelete,
    closeDeleteModal: store.closeDeleteModal,
    lastOptimisticUpdate: store.lastOptimisticUpdate,
    refreshData: store.refreshData,
    updateFiscalYear: store.updateItem,
    addFiscalYear: store.addItem,
    getFiscalYearById: store.getItemById,
  };
};

// 導出基礎 store 供其他模組使用
export { useFiscalYearStoreBase };